import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { AgitationSection } from './components/AgitationSection';
import { RealProblemSection } from './components/RealProblemSection';
import { WhyFailedSection } from './components/WhyFailedSection';
import { MechanismReveal } from './components/MechanismReveal';
import { ProductIntro } from './components/ProductIntro';
import { WhatsInside } from './components/WhatsInside';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { UrgencySection } from './components/UrgencySection';
import { FinalCTA } from './components/FinalCTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-charcoal selection:bg-amber/20" data-id="element-0">
      <Hero data-id="element-1" />
      <MechanismReveal data-id="element-2" />
      <AgitationSection data-id="element-3" />
      <RealProblemSection data-id="element-4" />
      <WhyFailedSection data-id="element-5" />
      <ProductIntro data-id="element-6" />
      <WhatsInside data-id="element-7" />

      <WhoIsThisFor data-id="element-8" />
      <Testimonials data-id="element-9" />
      <Guarantee data-id="element-10" />
      <UrgencySection data-id="element-11" />
      <FinalCTA data-id="element-12" />
      <FAQ data-id="element-13" />

      <Footer data-id="element-14" />
    </div>;
}